/* eslint-disable react/prop-types */
import React, { Suspense } from "react";
import Box from "@mui/material/Box";
import MainSection from "../_default/MainSection";
import DefaultProvider, { useLayout } from "../../_context/DefaultProvider";
import ScreenSizeProvider, {
  useScreenSize,
} from "../../_context/ScreenSizeProvider";
import LoadingBox from "../../_default/LoadingBox";
import ErrorBox from "../../_default/ErrorBox";
import SEOHead from "../_default/header/SEOHead";
import MenuButton from "../_default/MenuButton";
import { FooterBottom } from "../_default/footer";

const Layout1 = (props) => {
  const { children } = props;

  if (typeof window === "undefined") {
    return null;
  }

  if (React.Children.count(children) === 0) {
    console.warn("Default Layout expects at least one child.");
    return null;
  }

  return React.isValidElement(children) ? (
    <DefaultProvider>
      <ScreenSizeProvider>
        <Suspense
          fallback={
            <LoadingBox
              isLoading={true}
              text={"Adjusting layout for optimal ..."}
            />
          }
        >
          <Page {...props} />
        </Suspense>
      </ScreenSizeProvider>
    </DefaultProvider>
  ) : null;
};
const Page = (props) => {
  const { title, description, children } = props;
  const { isResizing, width } = useScreenSize();

  const { error, isError, isLoading } = useLayout();

  const childrenWithProps = React.Children.map(children, (child) => {
    return React.cloneElement(child, {});
  });

  return (
    <Box
      componnent="div"
      id="site-frontend-root"
      style={{
        position: "relative",
        padding: "0px",
        margin: "0px",
        minWidth: `${width}px`,
        width: `${width}px`,
        maxWidth: `${width}px`,
        minHeight: "100vh",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
      }}
    >
      <SEOHead title={title} description={description} />
      <MenuButton />
      <Box
        componnent="main"
        id="site-main-section"
        style={{
          position: "relative",
          padding: "0px",
          margin: "0px",
          width: "100%",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        }}
      >
        <LoadingBox isLoading={isLoading} text={"Loading..."} />
        <LoadingBox
          isLoading={isResizing}
          text={"Adjusting layout for optimal display..."}
        />

        <MainSection childrenWithProps={childrenWithProps} />
      
        <ErrorBox isError={isError} error={error} />
      </Box>
      <FooterBottom />
    </Box>
  );
};

export default Layout1;
